import _Table from "antd/es/table";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _Checkbox from "antd/es/checkbox";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _Form from "antd/es/form";
import React, { Component } from 'react';
import { css } from 'emotion';
import sanitizeHtml from 'sanitize-html';
import Matrix from '../../common/Question/Matrix';
import { Points, Emoji } from '../../common/Question/NewScale';
import MaterialSlider from './MaterialUI/Slider';
import { getLocalText } from '@/utilities/language';
var FormItem = _Form.Item;
var MatrixPC = /*#__PURE__*/function (_Component) {
  _inherits(MatrixPC, _Component);
  function MatrixPC(props) {
    var _this;
    _classCallCheck(this, MatrixPC);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(MatrixPC).call(this, props));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onValueClick", function (_ref) {
      var checked = _ref.checked,
        selected = _ref.selected,
        line = _ref.line,
        isSingleMatrix = _ref.isSingleMatrix,
        option = _ref.option,
        options = _ref.options,
        onChange = _ref.onChange,
        max = _ref.max;
      if (checked) {
        if (!selected[line.id] || isSingleMatrix) {
          selected[line.id] = [option.id];
        } else {
          selected[line.id].push(option.id);
          if (option.mutex) {
            selected[line.id] = selected[line.id].filter(function (optionId) {
              return !option.mutex.includes(optionId);
            });
          }
          selected[line.id] = (selected[line.id] || []).filter(function (el) {
            var _opt$mutex;
            if (el === 'other') {
              return true;
            }
            var opt = options.find(function (i) {
              return i.id === el;
            }) || {};
            if (!(opt === null || opt === void 0 ? void 0 : opt.mutex) || (opt === null || opt === void 0 ? void 0 : (_opt$mutex = opt.mutex) === null || _opt$mutex === void 0 ? void 0 : _opt$mutex.length) === 0) {
              return true;
            }
            return !opt.mutex.includes(option.id);
          });
        }
      } else if (selected[line.id]) {
        selected[line.id] = selected[line.id].filter(function (el) {
          return el !== option.id;
        });
      }
      var overDisabledIds = _this.state.overDisabledIds;
      if (max && selected[line.id] && selected[line.id].length == max) {
        var params = [];
        options.forEach(function (option) {
          if (selected[line.id].indexOf(option.id) < 0) {
            params.push(option.id);
          }
        });
        overDisabledIds[line.id] = params;
      } else if (overDisabledIds && overDisabledIds[line.id]) {
        delete overDisabledIds[line.id];
      }
      _this.setState({
        overDisabledIds: overDisabledIds
      });
      onChange.selected(selected[line.id], line.id);
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getColumn", function (_ref2) {
      var options = _ref2.options,
        _onChange = _ref2.onChange,
        formAnswer = _ref2.formAnswer,
        isSingleMatrix = _ref2.isSingleMatrix,
        transpose = _ref2.transpose,
        lines = _ref2.lines,
        isScaleMatrix = _ref2.isScaleMatrix,
        styleType = _ref2.styleType,
        max = _ref2.max,
        disabledIds = _ref2.disabledIds;
      var textKey = window.showMultiLang ? "".concat(window.language, "Text") : 'text';
      var labelKey = window.showMultiLang ? "".concat(window.language, "Label") : 'label';
      var overDisabledIds = _this.state.overDisabledIds;
      var newDisabledIds = disabledIds || overDisabledIds;
      var selected = formAnswer.selected;
      var length = options.length;
      var columnLen = window.innerWidth > 1440 ? 660 / length : 500 / length;
      var column = [{
        title: '',
        align: 'left',
        dataIndex: 'text',
        width: 150,
        render: function render(text, record) {
          return React.createElement("div", {
            dangerouslySetInnerHTML: {
              __html: sanitizeHtml((record === null || record === void 0 ? void 0 : record[textKey]) || 'Sub Question')
            }
          });
        }
      }];
      (transpose ? lines : options).forEach(function (el, index) {
        column.push({
          title: React.createElement("div", {
            style: {
              alignItems: !index ? 'flex-start' : index === (transpose ? lines : options).length - 1 ? 'flex-end' : 'center',
              textAlign: !index ? 'start !important' : index === (transpose ? lines : options).length - 1 ? 'right !important' : 'center !important'
            }
          }, React.createElement("div", {
            dangerouslySetInnerHTML: {
              __html: sanitizeHtml(isScaleMatrix ? (el === null || el === void 0 ? void 0 : el[labelKey]) || '' : (el === null || el === void 0 ? void 0 : el[textKey]) || '')
            }
          })),
          key: el.id,
          width: columnLen,
          render: function render(_, record) {
            var line = record;
            var option = el;
            if (transpose) {
              line = el;
              option = record;
            }
            if (index === 0 && isScaleMatrix) {
              return {
                props: {
                  colSpan: options.length
                },
                children: _this.renderScale({
                  onChange: _onChange,
                  line: line,
                  styleType: styleType,
                  selected: selected,
                  options: options
                })
              };
            }
            return {
              props: {
                colSpan: isScaleMatrix ? 0 : 1
              },
              children: React.createElement("div", {
                className: "flex justifyCenter"
              }, React.createElement(_Checkbox, {
                className: isSingleMatrix && 'isSingle',
                disabled: newDisabledIds && newDisabledIds[line.id] && newDisabledIds[line.id].includes(option.id),
                checked: selected[line.id] && selected[line.id].includes(option.id),
                onChange: function onChange(e) {
                  return _this.onValueClick({
                    checked: e.target.checked,
                    selected: selected,
                    line: line,
                    options: options,
                    option: option,
                    isSingleMatrix: isSingleMatrix,
                    onChange: _onChange,
                    max: max
                  });
                }
              }))
            };
          }
        });
      });
      return column;
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderScale", function (_ref3) {
      var line = _ref3.line,
        styleType = _ref3.styleType,
        selected = _ref3.selected,
        options = _ref3.options,
        superOnChange = _ref3.onChange;
      var labelKey = window.showMultiLang ? "".concat(window.language, "Label") : 'label';
      var selectedOne = selected[line.id] && selected[line.id][0];
      var selectedIdx = options.findIndex(function (opt) {
        return opt.id === selectedOne;
      });
      selectedIdx = selectedIdx < 0 ? undefined : selectedIdx + 1;
      var onChange = function onChange(value) {
        if (!value) return;
        _this.onValueClick({
          checked: value,
          selected: selected,
          line: line,
          options: options,
          option: options.find(function (o) {
            return o.id === value.toString();
          }),
          isSingleMatrix: true,
          onChange: superOnChange
        });
      };
      var marks = options.reduce(function (obj, option) {
        return _objectSpread({}, obj, _defineProperty({}, option.id, (option === null || option === void 0 ? void 0 : option[labelKey]) || ''));
      }, {});
      if (styleType === 'point') {
        return React.createElement(Points, {
          selected: selectedOne,
          onChange: onChange,
          marks: marks,
          isScaleMatrix: true
        });
      }
      if (styleType === 'star') {
        return React.createElement(Points, {
          selected: selectedOne,
          onChange: onChange,
          marks: marks,
          styleType: "star",
          isScaleMatrix: true
        });
      }
      if (styleType === 'emoji') {
        return React.createElement(Emoji, {
          selected: selectedOne,
          onChange: onChange,
          marks: marks,
          isScaleMatrix: true
        });
      }
      if (styleType === 'slider') {
        var id = "".concat(_this.props.question.id, "-").concat(line.id);
        return React.createElement("div", {
          className: "marginTop10 allWidth",
          id: id
        }, React.createElement(MaterialSlider, {
          selected: selectedIdx,
          isInsideMatrix: true,
          onChange: onChange,
          marks: marks,
          min: 1,
          max: options.length,
          id: id
        }));
      }
      return React.createElement(Points, {
        selected: selectedOne,
        onChange: onChange,
        marks: marks,
        isScaleMatrix: true
      });
    });
    _this.state = {
      overDisabledIds: {}
    };
    return _this;
  }
  _createClass(MatrixPC, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        question = _this$props.question,
        label = _this$props.label,
        answer = _this$props.answer;
      var custom = question.custom;
      var isScaleMatrix = custom.isScaleMatrix,
        isSingleMatrix = custom.isSingleMatrix,
        max = custom.max,
        options = custom.options,
        lines = custom.lines;
      var disabledIds = {};
      var lng = window.language || 'cn';
      if (!isScaleMatrix && !isSingleMatrix && max) {
        lines.forEach(function (line) {
          if (max && (answer === null || answer === void 0 ? void 0 : answer.selected) && answer.selected[line.id] && answer.selected[line.id].length == max) {
            var params = [];
            options.forEach(function (option) {
              if (answer.selected[line.id].indexOf(option.id) < 0) {
                params.push(option.id);
              }
            });
            disabledIds[line.id] = params;
          } else if (disabledIds && disabledIds[line.id]) {
            delete disabledIds[line.id];
          }
        });
      }
      return React.createElement(Matrix, this.props, function (_ref4) {
        var options = _ref4.options,
          error = _ref4.error,
          onChange = _ref4.onChange,
          formAnswer = _ref4.formAnswer,
          lines = _ref4.lines,
          isSingleMatrix = _ref4.isSingleMatrix,
          transpose = _ref4.transpose,
          isScaleMatrix = _ref4.isScaleMatrix,
          styleType = _ref4.styleType,
          min = _ref4.min,
          max = _ref4.max,
          realMin = _ref4.realMin,
          realMax = _ref4.realMax;
        var columns = _this2.getColumn({
          options: options,
          onChange: onChange,
          formAnswer: formAnswer,
          isSingleMatrix: isSingleMatrix,
          transpose: transpose,
          lines: lines,
          isScaleMatrix: isScaleMatrix,
          styleType: styleType,
          max: max,
          disabledIds: Object.keys(disabledIds).length > 0 ? disabledIds : null
        });
        return React.createElement(FormItem, {
          label: label,
          validateStatus: error.selected || error.text ? 'error' : null,
          hasFeedback: true,
          help: error.selected || error.text,
          required: question.required
        }, React.createElement("div", {
          id: "matrix",
          className: matrixWrap(window.textDirection.textAlign)
        }, React.createElement(_Table, {
          size: "small",
          columns: columns,
          dataSource: transpose ? options : lines,
          pagination: false,
          rowKey: function rowKey(record) {
            return record.id;
          },
          style: {
            borderColor: 'var(--text-color)'
          }
        })), Boolean(realMin || realMax) && lng === 'cn' && React.createElement("div", {
          style: {
            fontSize: 12,
            marginTop: 8
          }
        }, "* ", getLocalText('MultiChoice.min.or.max', min, max)));
      });
    }
  }]);
  return MatrixPC;
}(Component);
export { MatrixPC as default };
var _ref5 = "text-align:";
var _ref6 = ";.ant-table table{text-align:";
var _ref7 = ";color:var(--text-color) !important;}.ant-table-column-title{color:var(--text-color) !important;}.ant-table-wrapper{overflow-x:auto;}.ant-checkbox-wrapper-disabled{.ant-checkbox-disabled{opacity:0.3;}.ant-checkbox-inner{background:var(--checkbox-disabled-color) !important;border-color:var(--checkbox-disabled-color) !important;}}";
var matrixWrap = function matrixWrap(align) {
  return /*#__PURE__*/css(_ref5, align, _ref6, align, _ref7);
};

// const checkboxCls = css`
//   display: flex;
//   margin-right: 20px;
//   margin-bottom: 10px;
//   .other{
//     width: auto;
//   }
//   .ant-checkbox + span {
//     display: inline-block;
//     margin-top: -3px;
//   }
// `;